import React from "react";

import { i18n } from "../../translate/i18n";

export default function QueueCheckboxList({
	label,
	options = [],
	selectedIds = [],
	onChange,
	emptyText = i18n.t("queueSelect.empty") || "Nenhum setor disponível.",
}) {
	const handleToggle = (queueId) => {
		const exists = selectedIds.some((id) => String(id) === String(queueId));
		onChange(
			exists
				? selectedIds.filter((id) => String(id) !== String(queueId))
				: [...selectedIds, queueId]
		);
	};

	return (
		<div>
			{label && (
				<label className="mb-2 block text-sm font-medium text-default-800 dark:text-default-100">
					{label}
				</label>
			)}
			<div className="max-h-52 overflow-auto rounded-xl border border-default-200 bg-white p-2 dark:border-default-700 dark:bg-default-950">
				{options.length > 0 ? (
					options.map((queue) => {
						const checked = selectedIds.some((id) => String(id) === String(queue.id));

						return (
							<label
								key={queue.id}
								className="flex cursor-pointer items-center gap-3 rounded-lg px-3 py-2 hover:bg-default-100 dark:hover:bg-default-800"
							>
								<input
									type="checkbox"
									className="size-4 rounded border-default-300 text-primary focus:ring-primary"
									checked={checked}
									onChange={() => handleToggle(queue.id)}
								/>
								<span
									className="size-3 shrink-0 rounded-full"
									style={{ backgroundColor: queue.color || "#3b82f6" }}
								/>
								<span className="text-sm text-default-800 dark:text-default-100">
									{queue.name}
								</span>
							</label>
						);
					})
				) : (
					<p className="mb-0 px-3 py-2 text-sm text-default-500 dark:text-default-400">
						{emptyText}
					</p>
				)}
			</div>
		</div>
	);
}
